import { cilX } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { Modal, ModalBody } from 'reactstrap';
import '../../CSS/ContactUsModal.css';

const ContactUsModal = ({ header, isOpen, toggle }) => {
  const toPlayStore = () =>
    window.open('https://play.google.com/store/apps/details?id=com.blazor.dsps', '_blank');
  const toAppleStore = () =>
    window.open('https://apps.apple.com/us/app/4-delivery-service-partners/id6618150968', '_blank');

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="cu-modal-wrapper" centered>
      {/* Header */}
      <div className="cu-header">
        <div className="cu-header-inner">
          <span className="cu-header-eyebrow">6BY7 Platform</span>
          <span className="cu-header-title">{header || 'Contact Us'}</span>
        </div>
        <button className="cu-close-btn" onClick={toggle} aria-label="Close">
          <CIcon icon={cilX} style={{ width: 18, height: 18 }} />
        </button>
      </div>

      {/* Body */}
      <ModalBody className="cu-body">
        {/* Call via App */}
        <div className="cu-card cu-card--highlight">
          <div className="cu-card-icon-wrap">
            <span className="cu-card-icon">📱</span>
          </div>
          <div className="cu-card-content">
            <span className="cu-card-label">Fastest Way to Reach Us</span>
            <h3 className="cu-card-title">Call us from the 4DSPS App</h3>
            <p className="cu-card-text">
              Contacting 4DSPS is now easier than ever. Calling through the app is{' '}
              <strong>free</strong> — all you need is an internet or cellular connection.
            </p>

            {/* App Store Buttons */}
            <div className="cu-stores">
              <button className="cu-store-btn" onClick={toAppleStore}>
                <img src="AppStore.png" alt="Download on the App Store" className="cu-store-img" />
              </button>
              <button className="cu-store-btn" onClick={toPlayStore}>
                <img
                  src="GooglePlaystore.png"
                  alt="Get it on Google Play"
                  className="cu-store-img"
                />
              </button>
            </div>
          </div>
        </div>

        {/* Contact Details */}
        <div className="cu-details">
          {/* Email */}
          <a className="cu-detail-row" href="mailto:info@4dsps.com">
            <div className="cu-detail-icon">✉</div>
            <div className="cu-detail-text">
              <span className="cu-detail-label">Email Us</span>
              <span className="cu-detail-value">info@4dsps.com</span>
            </div>
            <span className="cu-detail-arrow">→</span>
          </a>

          {/* Phone */}
          <a className="cu-detail-row" href="tel:+18557894346">
            <div className="cu-detail-icon">☎</div>
            <div className="cu-detail-text">
              <span className="cu-detail-label">Call Us</span>
              <span className="cu-detail-value">UAN: +1 855 789 4DIM</span>
            </div>
            <span className="cu-detail-arrow">→</span>
          </a>

          {/* Address */}
          <div className="cu-detail-row cu-detail-row--static">
            <div className="cu-detail-icon">◎</div>
            <div className="cu-detail-text">
              <span className="cu-detail-label">Our Address</span>
              <span className="cu-detail-value">402 Rolling Green Ave, New Castle DE 19720</span>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ContactUsModal;
